import { axiosClient } from './AxiosClient'

function exportUser(callback, errorCallback){
    let url = "/report/exportUser"

    axiosClient({
        url: url,
        responseType: "arraybuffer",
        method: 'GET',
        headers:{
            'Content-Type': "blob"
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function getExampleFile(callback, errorCallback){
    let url = "/report/template"

    axiosClient({
        url: url,
        responseType: "arraybuffer",
        method: 'GET',
        headers:{
            'Content-Type': "blob"
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function importUser(file, callback, errorCallback){
    let url = "/report/importUser"

    var bodyForm = new FormData()
    bodyForm.append("excel", file)

    axiosClient({
        url: url,
        method: "POST",
        data: bodyForm,
        headers:{
            "Content-Type": "multipart/form-data; charset=utf-8;"
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { exportUser, importUser, getExampleFile }